module.exports = __webpack_public_path__ + "static/media/mechatronic-eng.e2b4e257.jpg";